
export default {
  apiPath: 'https://devops.citadel-services.com/api/v1',
};
